/**
 * RxJSON schemas for local-first org / roster data.
 * Bump pocket DB name when schemas change incompatibly.
 */

export const organizationsSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    name: { type: 'string' },
    bylaws_config: { type: 'object' },
    quorum_threshold: { type: 'number' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'name', 'quorum_threshold'],
  indexes: ['updated_at'],
};

/** User shell — no org/role (those live on memberships). */
export const profilesSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    display_name: { type: 'string' },
    updated_at: { type: 'string' },
  },
  required: ['id'],
  indexes: ['updated_at'],
};

export const organizationMembershipsSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    user_id: { type: 'string', maxLength: 64 },
    organization_id: { type: 'string', maxLength: 64 },
    role: { type: 'string', maxLength: 32 },
    modules: { type: 'object' },
    is_active: { type: 'boolean' },
    organization_name: { type: 'string' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'user_id', 'organization_id', 'role', 'is_active'],
  indexes: ['user_id', 'organization_id', 'updated_at'],
};

export const membersSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    organization_id: { type: 'string', maxLength: 64 },
    name: { type: 'string' },
    is_active: { type: 'boolean' },
    voting_rights: { type: 'boolean' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'organization_id', 'name', 'is_active', 'voting_rights'],
  indexes: ['organization_id', 'updated_at'],
};

export const committeesSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    organization_id: { type: 'string', maxLength: 64 },
    name: { type: 'string' },
    chair_id: { type: 'string', maxLength: 64 },
    is_standing: { type: 'boolean' },
    description: { type: 'string' },
    chair_name: { type: 'string' },
    members: { type: 'array' },
    referred_items: { type: 'array' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'organization_id', 'name', 'is_standing'],
  indexes: ['organization_id', 'updated_at'],
};

export const meetingsSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    organization_id: { type: 'string', maxLength: 64 },
    date: { type: 'string' },
    minutes_raw: { type: 'string' },
    is_closed: { type: 'boolean' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'organization_id', 'date', 'is_closed'],
  indexes: ['organization_id', 'updated_at'],
};

export const motionsArchiveSchema = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 64 },
    meeting_id: { type: 'string', maxLength: 64 },
    text: { type: 'string' },
    result: { type: 'string' },
    type: { type: 'string' },
    updated_at: { type: 'string' },
  },
  required: ['id', 'meeting_id', 'text', 'result', 'type'],
  indexes: ['meeting_id', 'updated_at'],
};

export const pocketCollections = {
  organizations: { schema: organizationsSchema },
  profiles: { schema: profilesSchema },
  organization_memberships: { schema: organizationMembershipsSchema },
  members: { schema: membersSchema },
  committees: { schema: committeesSchema },
  meetings: { schema: meetingsSchema },
  motions_archive: { schema: motionsArchiveSchema },
};
